/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: {
    maxHeight: {
      description: 'Whether MultiselectFilter modal should expand responsively to content or a set maximu height',
      type: 'state',
      values: [ true ]
    },
    maxWidth: {
      description: 'Whether MultiselectFilter modal should expand to content or a set maximuh width',
      type: 'state',
      values: [ true ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs' ] },
      tokens: {
        buttonDirection: 'column',
        minHeight: '100%',
        minWidth: '100%'
      }
    },
    {
      if: { maxHeight: true, viewport: [ 'sm', 'md', 'lg', 'xl' ] },
      tokens: { maxHeightSize: 480 }
    },
    {
      if: { maxWidth: true, viewport: [ 'sm', 'md', 'lg', 'xl' ] },
      tokens: { maxWidthSize: 544 }
    }
  ],
  tokens: {
    buttonDirection: 'row',
    headerFontColor: '#414547',
    headerFontName: 'HelveticaNow',
    headerFontSize: 16,
    headerFontWeight: '500',
    headerLineHeight: 1.5,
    maxHeightSize: 0,
    maxWidthSize: 0,
    minHeight: 412,
    minWidth: 320,
    subHeaderFontName: 'HelveticaNow',
    subHeaderFontSize: 14,
    subHeaderFontWeight: '400',
    subHeaderLineHeight: 1.4
  }
}
export default theme
